module.exports = __webpack_public_path__ + "media/svg-new/019-question 2-9dd38dee.svg";